// Module
var code = "<ul class=\"js-checkbox-group-container\" \r\n    style=\"position:absolute;overflow:hidden;margin:0;padding:0;{{>position}}\">\r\n    {{#.dataArray}}\r\n        <li><terceraCheckBox text={{.text}} checked=\"{{.checked}}\"/></li>\r\n    {{/}}\r\n</ul>";
// Exports
export default code;